import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { renderRetreatDateHeader } from "./retreatDateHeader";
import "../assets/css/AppDatePicker.css";

const PORTAL_ID = "ls-calendar-portal";

function ensureCalendarPortal() {
  if (typeof document === "undefined") return;
  if (!document.getElementById(PORTAL_ID)) {
    const portal = document.createElement("div");
    portal.id = PORTAL_ID;
    document.body.appendChild(portal);
  }
}

const AppDatePicker = ({
  calendarClassName = "",
  popperClassName = "",
  popperProps,
  ...props
}) => {
  useEffect(() => {
    ensureCalendarPortal();
  }, []);

  return (
    <DatePicker
      {...props}
      renderCustomHeader={renderRetreatDateHeader}
      showPopperArrow={false}
      calendarClassName={`ls-cal ${calendarClassName}`.trim()}
      popperClassName={`ls-cal-popper ${popperClassName}`.trim()}
      portalId={PORTAL_ID}
      popperProps={{ strategy: "fixed", ...(popperProps || {}) }}
    />
  );
};

export default AppDatePicker;
